import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { Meta, Title, DomSanitizer } from '@angular/platform-browser';
import { formatDate, Location } from '@angular/common';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { APIService } from '../../services/api.service';
import { JobService } from '../../services/job.service.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { SitemapComponent } from 'src/app/shared/sitemap/sitemap.component';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-job-blogs',
  templateUrl: './app-job-blogs.component.html',
  styleUrls: ['./app-job-blogs.component.scss'],
  standalone: false,
})
export class JobBlogsComponent implements OnInit {
  eventData: any = [];
  canShare = false;
  emailId = 'team@inforida.com';
  isBrowser: boolean = false;

  constructor(
    public api: APIService,
    public jobService: JobService,
    private router: Router,
    private location: Location,
    private title: Title,
    private meta: Meta,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private deviceDetectorService: DeviceDetectorService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  openBlogLink(blogNo) {
    switch (blogNo) {
      case 1:
        window.open(
          'https://blog.inforida.com/navigating-the-cbse-results-2024-insights-and-how-inforida-can-enhance-school-management/',
          '_blank'
        );
        break;
      case 2:
        window.open(
          'https://blog.inforida.com/the-secret-to-school-success-unlocking-inforidas-powerful-features/',
          '_blank'
        );
        break;
      case 3:
        window.open(
          'https://blog.inforida.com/5-ways-inforida-can-make-teachers-lives-easier-and-more-fulfilling/',
          '_blank'
        );
        break;
      case 4:
        window.open(
          'https://blog.inforida.com/managing-school-finances-with-inforida-a-comprehensive-guide-for-school-administrators/',
          '_blank'
        );
        break;
      case 5:
        window.open('https://blog.inforida.com/', '_blank');
        break;
    }
  }
}
